import { useState } from 'react';
import { toast } from 'sonner';

import { Icons } from '@/assets/icons/icons';
import mobileDownloadUrl from '@/assets/images/mobile-download-qr.svg';
import { Button } from '@/components/ui/Button';
import { Dialog } from '@/components/ui/dialog';
import { YStack } from '@/components/ui/layout/layout';
import { logError } from '@/lib/errorLogging';

import { type BaseModalFCProps, type ModalFC } from './modalsManager';

const APP_STORE_URL = 'https://littlebird.ai/mobile-app';

export interface DownloadMobileAppModalProps extends BaseModalFCProps {}

export const DownloadMobileAppModal: ModalFC<DownloadMobileAppModalProps> = ({
  open,
  onOpenChange,
}) => {
  const [linkCopied, setLinkCopied] = useState(false);

  const handleCopyLink = async () => {
    try {
      await navigator.clipboard.writeText(APP_STORE_URL);
      setLinkCopied(true);
      setTimeout(() => {
        setLinkCopied(false);
      }, 2000);
    } catch (err) {
      logError(err, 'Failed to copy mobile app link');
      toast.error("Couldn't copy link. Please try again");
    }
  };

  return (
    <Dialog.Root open={open} onOpenChange={onOpenChange}>
      <Dialog.Content className="max-w-md">
        <Dialog.Header>
          <Dialog.Title>Download the Mobile App</Dialog.Title>
          <Dialog.Description>
            Scan the QR code with your device or copy the link to download the
            Littlebird Companion App
          </Dialog.Description>
        </Dialog.Header>
        <YStack className="gap-8 py-4 items-center">
          <img
            src={mobileDownloadUrl}
            alt="QR code to download Littlebird mobile app"
            className="size-56 border border-border rounded-2xl bg-white shadow-md"
          />
          <Button onClick={handleCopyLink} variant="secondary" tabIndex={-1}>
            <Icons.copy className="size-4" />
            <span>{linkCopied ? 'Link Copied!' : 'Copy Link'}</span>
          </Button>
        </YStack>
      </Dialog.Content>
    </Dialog.Root>
  );
};
